import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import MatchSearchResults from "./MatchSearch/MatchSearchResults";
import MatchSearchCriteria from "./MatchSearch/MatchSearchCriteria";

const toolbarHeight = 64;
const footerHeight = 125;
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    position: "relative",
    overflowY: "clip",
  },
  searchContentContainer: {
    height: `calc(100% - ${footerHeight + toolbarHeight}px)`,
    overflowY: "auto",
    overflowX: "clip",
  },
  searchContent: { padding: theme.spacing(0.5) },
}));

export default function AdminMatches() {
  const classes = useStyles();
  const [searchCriteria, setSearchCriteria] = React.useState({});

  return (
    <div className={classes.root}>
      <div className={classes.searchContentContainer}>
        <div className={classes.searchContent}>
          <Typography variant="h2" style={{ margin: "1rem 0" }}>
            Match Search
          </Typography>
          <MatchSearchCriteria searchCriteria={searchCriteria} setSearchCriteria={setSearchCriteria} />
          <MatchSearchResults inputSearchCriteria={searchCriteria} defaultRowsPerPage={5} />
        </div>
      </div>
    </div>
  );
}
